import React, { Fragment } from 'react';
import { Link } from 'react-router-dom';
import { Dialog, Transition } from '@headlessui/react';
import PropTypes from 'prop-types';
import { XIcon } from '@heroicons/react/outline';
import Video from '../VideoJS';
import { useAuth } from '../../context/AuthContext';
import BrightcovePlayer from '../brightcove-player';

export default function Trailer({ open, setOpen, videoId }) {
  const { user } = useAuth();

  return (
    <Transition.Root show={open} as={Fragment}>
      <Dialog as="div" auto-reopen="true" className="fixed z-10 inset-0 overflow-y-auto" onClose={setOpen}>
        <div className="block items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center">
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <Dialog.Overlay className="fixed inset-0 bg-black bg-opacity-90 transition-opacity" />
          </Transition.Child>

          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="block absolute top-0 right-0 pt-4 pr-4">
              <button
                type="button"
                className="rounded-md text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-opex"
                onClick={() => setOpen(false)}
              >
                <span className="sr-only">Close</span>
                <XIcon className="h-6 w-6" aria-hidden="true" />
              </button>
            </div>
          </Transition.Child>

          <span className="inline-block align-middle h-screen" aria-hidden="true">
            &#8203;
          </span>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            enterTo="opacity-100 translate-y-0 sm:scale-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100 translate-y-0 sm:scale-100"
            leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
          >
            <div className="inline-block rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all my-8 align-middle max-w-7xl w-full p-6">
              <BrightcovePlayer 
              slug=""
              chapterSlug=""
              videoId={videoId}
              updateRating={() => {}}
              isLastVideo={false} />
              {!user && (
                <div className="mt-5 sm:mt-6 flex justify-end">
                  <Link
                    to="/plans"
                    className="inline-flex justify-center sm:w-full md:w-32 w-full rounded-md border border-transparent shadow-sm px-4 py-3 bg-blue-opex text-base text-white font-bold uppercase hover:bg-blue-darker focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-darker sm:text-sm"
                  >
                    Sign Up
                  </Link>
                </div>
              )}
            </div>
          </Transition.Child>
        </div>
      </Dialog>
    </Transition.Root>
  );
}

Trailer.propTypes = {
  videoId: PropTypes.string,
  open: PropTypes.bool,
  setOpen: PropTypes.func
};
